import { Component, inject } from '@angular/core';
import { CategoryStore } from '../../../stores/category/category.state';
import { BaseFilterComponent } from '../base-filter/base-filter.component';
import { Category } from '../../../models/category';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagFilterDropdownComponent } from '../../atoms/tag-filter-dropdown/tag-filter-dropdown.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ButtonModule } from 'primeng/button';
import { NgClass, NgIf } from '@angular/common';
import { DebugComponent } from '../../atoms/debug/debug.component';

@Component({
  selector: 'app-category-filter',
  standalone: true,
  imports: [
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ReactiveFormsModule,
    TagFilterDropdownComponent,
    TriStateCheckboxModule,
    FormsModule,
    NgIf,
    TreeSelectModule,
    DebugComponent,
    NgClass,
  ],
  templateUrl: './category-filter.component.html',
  styleUrl: './category-filter.component.scss',
})
export class CategoryFilterComponent extends BaseFilterComponent<Category> {
  readonly store = inject(CategoryStore);

  constructor() {
    super();
  }
}
